// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"27ef5cfc","879":"c5851aa9"}[chunkId] + ".chunk.js";
};